import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  createVehicleTrackingAttachment,
  getVehicleTrackingAttachments,
} from 'src/redux/Actions/VehicleTracking';
import UploadInvoiceComponent from 'src/components/VehicleTrackingDetails/Invoice/UploadInvoiceComponent';
import 'src/style/invoice.css';
const FILE_TYPE_INVOICE = 1;
export default function InvoiceUploadModal({ show, onHide }) {
  const dispatch = useDispatch();
  const { vehicleTrackingNumber, workflowStageId } = useParams();
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [pendingFiles, setPendingFiles] = useState([]);

  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const themeColor = authReducer.userData.tenant?.theme;

  const handleFileUpload = async (files) => {
    try {
      setUploading(true);
      setErrorMessage('');

      const formData = new FormData();
      files.forEach((file) => formData.append('file', file));
      formData.append('tenant_organisation_id', tenantOrganisationId);
      formData.append('vehicle_tracking_number', vehicleTrackingNumber);
      formData.append('file_type', FILE_TYPE_INVOICE);
      if (workflowStageId) {
        formData.append('workflow_stage_id', workflowStageId);
      }

      await dispatch(createVehicleTrackingAttachment(formData));

      // Refresh invoice list in Redux so InvoiceTab picks it up
      dispatch(
        getVehicleTrackingAttachments(
          tenantOrganisationId,
          vehicleTrackingNumber,
          FILE_TYPE_INVOICE,
        ),
      );

      // Close modal
      handleClose();
    } catch (error) {
      setErrorMessage(
        error.response?.data?.error ||
          error.message ||
          'Failed to upload invoice. Please try again.',
      );
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setUploading(false);
    setErrorMessage('');
    setPendingFiles([]);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="text-lg text-semi-bold">
          Upload Invoice
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="div-flex-column div-align-center rg-20 container-padding-20">
          {errorMessage && (
            <div className="alert alert-danger py-2 w-100" role="alert">
              {errorMessage}
            </div>
          )}
          <p className="text-md text-grey mb-0 text-center">
            Take a Photo or Upload invoice images to extract line items using
            AI. You can select multiple files at once.
          </p>
          <UploadInvoiceComponent
            onFileUpload={handleFileUpload}
            uploading={uploading}
            onFilesUploaded={setPendingFiles}
            hideUploadButton
          />
          {uploading && (
            <div className="div-flex-column div-align-center rg-10">
              <div className="spinner-border" role="status" />
              <span className="text-sm">Uploading invoice...</span>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="div-flex-row div-space-between py-2">
        <button
          className={`vehicle-tracking-detail-add-vehcile-data-btn theme-text-${themeColor} theme-border-color-${themeColor} div-align-center`}
          onClick={handleClose}
        >
          <span className="text-md">Cancel</span>
        </button>
        {pendingFiles.length > 0 && (
          <button
            className={`vehicle-tracking-detail-move-stage-btn theme-background-${themeColor} div-align-center`}
            onClick={() => handleFileUpload(pendingFiles)}
            disabled={uploading}
          >
            <span className="text-md">
              {uploading
                ? 'Uploading...'
                : `Upload ${pendingFiles.length} ${pendingFiles.length === 1 ? 'File' : 'Files'}`}
            </span>
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
